import { inject, Pipe, PipeTransform } from "@angular/core";
import { FormatterService } from "src/app/services/formatter.service";

@Pipe({
  name: "duration",
  pure: true,
  standalone: false
})
export class DurationPipe implements PipeTransform {
  readonly #formatterService = inject(FormatterService);

  transform(
    value: string | number | undefined,
    trigger: number | null,
    withSuffix: boolean = true,
    fromNow: boolean = true,
    units: "seconds" | "minutes" | "months" = "seconds",
    disableHumanize: boolean = false
  ): string {
    if (fromNow) {
      return this.#formatterService.durationFromNow({
        value,
        withSuffix,
        disableHumanize
      });
    }

    return this.#formatterService.duration({
      value,
      withSuffix,
      units,
      disableHumanize
    });
  }
}
